<template>
  <fts-design-modal
    class="fts-module-create-modal"
    append-header-class="module-create-modal__header"
    append-content-class="module-create-modal__body"
    @closed="reset"
    ref="ftsModuleCreateModal"
  >
    <!-- header -->
    <template #header>
      <fts-btn lg text icon @click="close">
        <font-awesome-icon :icon="['fas', 'times']" />
      </fts-btn>
    </template>
    <!-- body -->
    <template #body>
      <div class="design-modal-content__header">
        <div class="design-modal-content__header-title">
          Create a new module for your business app
        </div>
        <div class="design-modal-content__header-description">
          It can be a process or a workflow like ticketing, approval, or leave application. <br/>
          Or, it can be a collection of entries like employees, products or customers
        </div>
      </div>

      <div class="module-create-form comfort-form-design">
        <div class="module-create-emoji-wrapper">
          <fts-emoji
            append-to-body
            :toggle-size="56"
            placement="bottom"
            v-model="formData.emoji"
            class="module-create-emoji"
          />
        </div>

        <div class="fts-form-group">
          <fts-form-label placement="top">Module Name</fts-form-label>
          <input 
            class="fts-form-control" 
            v-model="formData.name" 
            ref="moduleName"
            @input="setModuleEmoji();$v.formData.name.$touch();" 
          />
          <div class="fts-form-error" v-if="$v.formData.name.$error">
            {{getModuleNameError()}}
          </div>
        </div>

        <div class="fts-text-right">
          <fts-btn
            text 
            text-transform-init 
            box-shadow-none
            @click="close"
          >
            Cancel
          </fts-btn>
          <fts-btn 
            color="primary" 
            text-transform-init 
            box-shadow-none
            @click="done"
          >
            Create Module
          </fts-btn>
        </div>
      </div>
    </template>
  </fts-design-modal>
</template>

<script>
import Vue from 'vue';
import Vuelidate from 'vuelidate';
Vue.use(Vuelidate);

import { store as canvasDesignStore } from '../store/canvasDesignStore';
import designValidator from '../commons/designValidator';

import FTSDesignModal from '../design/FTSDesignModal';

import FTSBtn from '../elements/FTSBtn';
import FTSEmoji from '../elements/FTSEmoji';
import FTSFormLabel from '../elements/FTSFormLabel';

export default {
  components: {
    'fts-design-modal': FTSDesignModal,
    'fts-btn': FTSBtn,
    'fts-emoji': FTSEmoji,
    'fts-form-label': FTSFormLabel
  },
  props: {
    modules: Array
  },
  data: () => ({
    resolve: null,
    formData: {}
  }),
  validations() {
    let formData = {};
    formData = designValidator.moduleDesign(this.modules);
    return { formData };
  },
  methods: {
    async show() {
      return new Promise((resolve) => {
        this.resolve = resolve;
        this.$refs.ftsModuleCreateModal.show();
        this.$nextTick(() => {
          this.$refs.moduleName.focus();
        });
      });
    },
    close() {
      this.$refs.ftsModuleCreateModal.close();
    },
    reset() {
      this.$v.$reset();
      Object.assign(this.$data, this.$options.data.apply(this));
    },
    done() {
      this.$v.formData.$touch();
      if (this.$v.formData.$invalid) {
        return;
      }
      this.resolve && this.resolve(this.formData);
      this.close();
    },
    setModuleEmoji: _.debounce(async function() {
      if (this.formData.name && !this.formData.emoji) {
        try {
          const res = await canvasDesignStore.dispatch("ai", {
            type: "emoji",
            text: this.formData.name
          });
          if (res.data) {
            this.$set(this.formData, "emoji", res.data);
          }
        } catch(err) {
          console.error(err);
        }
      }
    }, 800),
    getModuleNameError() {
      return designValidator.moduleDesignError(this.$v.formData, "name");
    }
  }
}
</script>

<style lang="scss">
.fts-module-create-modal {
  .module-create-modal__header {
    justify-content: flex-end;
    padding: .75rem;
  }
  .module-create-modal__body {
    padding: 0 1.5rem 1.5rem;
  }
  .module-create-form {
    padding-top: 1rem;
  }
  .module-create-emoji-wrapper {
    margin-bottom: 1rem;
    text-align: center;
  }
  .module-create-emoji {
    display: inline-flex;
  }
}
</style>